<template>
  <div class="not-found">
    This page does not exist. <router-link :to="{ name: 'home' }">Go back</router-link>
  </div>
</template>

<script>
export default {
  name: 'not-found'
}
</script>
